/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Barra from "./Barra/Barra";
import Seccion_Home from "./Secciones/Seccion_Home";
import Footer from "./Footer";
import {SECCIONES} from "../Constantes";

const Pagina = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Barra/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Seccion_Home/>
            </Grid>

            <Grid id={SECCIONES[2]} container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 6}}>
                <Footer/>
            </Grid>

        </Grid>
    )

}
export default Pagina